(function () {
  'use strict';

  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-faq-item]'));

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-faq-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', () => this.toggle(item));
      });

      if (this.dataset.openFirst === 'true' && this.items.length) {
        this.open(this.items[0]);
      }
    }

    toggle(item) {
      const isOpen = item.classList.contains('is-open');
      // Enforce "only one at a time": close everything first, then reopen
      // the clicked item only if it wasn't already the open one.
      this.items.forEach((otherItem) => this.close(otherItem));
      if (!isOpen) this.open(item);
    }

    open(item) {
      item.classList.add('is-open');
      const trigger = item.querySelector('[data-faq-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    close(item) {
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-faq-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('faq-accordion')) {
    customElements.define('faq-accordion', FaqAccordion);
  }
})();
